import { gql } from '@apollo/client';

import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const studentAssessmentStimulusFragment = gql`
  fragment StudentAssessmentStimulusFragment on Assessment {
    id
    assignedData {
      stimulusResourceIds
    }
    stimulusResources {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;
